import { render, staticRenderFns } from "./con-comunidad.vue?vue&type=template&id=49fb939c"
import script from "./con-comunidad.vue?vue&type=script&lang=js"
export * from "./con-comunidad.vue?vue&type=script&lang=js"
import style0 from "./con-comunidad.vue?vue&type=style&index=0&id=49fb939c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports